
import { useStore } from "vuex";
import { computed, defineComponent, onMounted, ref, watch } from "vue";
import CharacterLoad from "./CharacterLoad.vue";
import CharacterPresets from '@/data/presets';
import GenericPanel from "../GenericPanel.vue";
import GenericButton from "../GenericButton.vue";
import GenericTabs from "../GenericTabs.vue";

export default defineComponent({
  components: {
    CharacterLoad,
    GenericPanel,
    GenericButton,
    GenericTabs
},
  name: "LoadMenu",
  setup() {
    const store = useStore();
    const panelState = ref('default')
    const characters = ref([])
    const presets = ref(CharacterPresets)
    const activeSection = ref("Saved");
    const selectedTab = ref('SAVED');
    const handleActiveTab = (tab) => {
      selectedTab.value = tab.name;
    };
    const closePanel = () => {
      store.dispatch('showDefaultCharStats')
    }
    watch(() => store.state.library, () => {
      characters.value = Object.values(store.state.library);
    })
    onMounted(() => {
      characters.value = Object.values(store.state.library || {});
    });
    const tabs = computed(() => {
      return [
        {
          name: 'SAVED',
          selected: selectedTab.value === 'SAVED',
        },
        {
          name: 'PRESETS',
          selected: selectedTab.value === 'PRESETS'
        }
      ]
    })
    return {
      state: store.state,
      panelState,
      characters,
      presets,
      closePanel,
      activeSection,
      tabs,
      selectedTab,
      handleActiveTab
    };
  },
});
